import { DATE_FORMATS_FNS } from "components";
import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { formatDate } from "utils/dateHelperFunctions";

import type { SelectedDatesData } from "modules/Appointments/queryKeys";

export const useSelectedDates = () =>
  useTypedQuery({
    queryKey: AppointmentsQueryKeys.selectedDatesToList,
    initialData: { startDate: formatDate(new Date(), DATE_FORMATS_FNS.timeCarAppDate), endDate: formatDate(new Date(), DATE_FORMATS_FNS.timeCarAppDate) }
  }).data;

export const setSelectedDates = (dates: [Date | null, Date | null]) => {
  const [start, end] = dates;

  const datesData: SelectedDatesData = {
    startDate: start ? formatDate(start, DATE_FORMATS_FNS.timeCarAppDate) : formatDate(new Date(), DATE_FORMATS_FNS.timeCarAppDate),
    endDate: end ? formatDate(end, DATE_FORMATS_FNS.timeCarAppDate) : null
  };

  typedQueryClient.setQueryData(AppointmentsQueryKeys.selectedDatesToList, datesData);
};
